export const buildCurrencyApiConfig = () => ({
    url: '/api/pricing/currencies',
    method: 'GET',
});
